export enum AnswerResponseType {
  Correct = 'CORRECT',
  Incorrect = 'INCORRECT',
}
